import React from 'react';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export const Term = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '36px 24px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 }}>
        {t('termPage.title')}
      </h2>
      <div className="ms-card" style={{ padding: 28 }}>
        {[
          { t: t('termPage.section1Title'), p: t('termPage.section1Content') },
          { t: t('termPage.section2Title'), p: t('termPage.section2Content') },
          { t: t('termPage.section3Title'), p: t('termPage.section3Content') },
          { t: t('termPage.section4Title'), p: t('termPage.section4Content') },
          { t: t('termPage.section5Title'), p: t('termPage.section5Content') },
          { t: t('termPage.section6Title'), p: t('termPage.section6Content') },
          { t: t('termPage.section7Title'), p: t('termPage.section7Content') },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>{s.t}</h3>
            <p style={{ fontSize: 14, color: colors.muted, lineHeight: 1.7, margin: 0 }}>{s.p}</p>
          </div>
        ))}
        <p style={{ fontSize: 14, color: colors.muted, marginTop: 10 }}>
          {t('termPage.contact')}{' '}
          <a href="https://t.me/mailsngon" target="_blank" rel="noreferrer">
            Telegram
          </a>
        </p>
      </div>
    </div>
  );
};
